module.exports = __webpack_public_path__ + "img/bg7.c329d2cc.jpg";